import { SecretDiscussPage } from './SecretDiscussPage';
export default SecretDiscussPage;
